// @ts-strict-ignore
import type { WorkflowState } from '../state';

// ================ Rule Explainability Reducers ================

export function setThresholdOutputResults(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['thresholdResults'];
  },
) {
  state.workflowFeatures.ruleExplainability.thresholdResults = action.payload;
}

export function setIsRuleExplainabilityPortfolioEvaluation(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['isPortfolioEvaluation'];
  },
) {
  state.workflowFeatures.ruleExplainability.isPortfolioEvaluation = action.payload;
}

export function setEntityToken(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['entityToken'];
  },
) {
  state.workflowFeatures.ruleExplainability.entityToken = action.payload;
}

export function setEvaluationToken(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['evaluationToken'];
  },
) {
  state.workflowFeatures.ruleExplainability.evaluationToken = action.payload;
}

export function setEvaluationTagNames(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['setTagNames'];
  },
) {
  state.workflowFeatures.ruleExplainability.setTagNames = action.payload;
}

export function setEvaluationOutcome(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['setOutcome'];
  },
) {
  state.workflowFeatures.ruleExplainability.setOutcome = action.payload;
}

export function setDimensions(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['dimensions'];
  },
) {
  state.workflowFeatures.ruleExplainability.dimensions = action.payload;
}

export function setSelectedEvidenceThresholdId(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['thresholdId'];
  },
) {
  state.workflowFeatures.ruleExplainability.thresholdId = action.payload;
}

export function setMatrixModelResults(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['ruleExplainability']['matrixModelResults'];
  },
) {
  state.workflowFeatures.ruleExplainability.matrixModelResults = action.payload;
}

// ================ Threshold Simulator ================

export function setSelectedThresholdSimThresholdId(
  state: WorkflowState,
  action: {
    payload: WorkflowState['workflowFeatures']['thresholdSimulator']['thresholdId'];
  },
) {
  state.workflowFeatures.thresholdSimulator.thresholdId = action.payload;
}
